import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getToken } from "./localStorageService";
import { BASE_URL_STAGINGHTTP, INITIAL_TOKEN, BASE_URL_STAGING } from "../../config/config";

export const baseApi = createApi({
  reducerPath: "baseApi",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL_STAGING,
    prepareHeaders: (headers, { getState }) => {
      headers.set("token", INITIAL_TOKEN);
      headers.set("Accept", "application/json");
      let auth_token = getToken();
      if (auth_token) {
        headers.set("authorization", auth_token);
      }

      return headers;
    },
  }),
  endpoints: () => ({}),
});
